import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async getBanners({ commit, state }, { channel = 'eshop' } = {}) {
    commit('beginRequest', channel);
    const requestId = state.requestId;
    try {
      const { data } = await request.get('/banners', {
        params: { paginated: 0, channel },
      });

      if (state.requestId !== requestId) return;

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      commit('setData', data.banners);

      commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      if (state.requestId !== requestId) return;
      console.log(err);
      commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
